import constants from '../../constants';
import defaultTheme from './defaultTheme';
export default {
  ...defaultTheme,
  emptyMessage: constants.Colors.GreyBlue2,
  emptyIcon: '#4d5282'
};
